import { Delete, Edit } from '@mui/icons-material';
import {
    Box,
    IconButton,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableRow,
    Tooltip,
} from '@mui/material';
import AppModal from 'components/AppModal';
import ListHeader from 'page-sections/group-registration/ListHeader';
import PopUpConfirmation from 'page-sections/group-registration/PopUpConfirmation';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axiosInstance from 'utils/axios';
import formatCurrency from 'utils/formatCurrency';

const GroupRegistrationListPage = () => {
    const navigate = useNavigate();
    const [tableData, setTableData] = useState([]);
    const [openModal, setOpenModal] = useState(false);
    const [disableButtonPopUp, setDisableButtonPopUp] = useState(false);
    const [dataToDelete, setDataToDelete] = useState([]);

    const handleRegistrationUpload = () =>
        navigate('/dashboard/group-registration/upload');

    const getData = async () => {
        await axiosInstance
            .get(`/api/register-groups`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        'accessToken',
                    )}`,
                },
            })
            .then(({ data }) => {
                setTableData(data);
            })
            .catch((err) => console.log(err));
    };
    useEffect(() => {
        getData();
    }, []);

    const deleteRegistration = async (data) => {
        setDataToDelete(data);
        setOpenModal(true);
    };

    const showButtonDelete = (status) => {
        if (['new', 'rejected'].includes(status.value)) {
            return 'block';
        }
        return 'none';
    };

    const handleCloseModal = () => {
        setOpenModal(false);
        setDisableButtonPopUp(false);
    };

    const handleApprove = async () => {
        setDisableButtonPopUp(true);
        await axiosInstance
            .delete(`api/register-groups/${dataToDelete.id}`)
            .then(() => {
                handleCloseModal();
                getData();
            })
            .catch((err) => {
                console.log(err);
                handleCloseModal();
            });
    };
    return (
        <Box pt={2} pb={4}>
            <ListHeader handleClick={handleRegistrationUpload} />
            <AppModal open={openModal} handleClose={handleCloseModal}>
                <PopUpConfirmation
                    disableButton={disableButtonPopUp}
                    handleCancel={handleCloseModal}
                    handleApprove={handleApprove}
                />
            </AppModal>
            <TableContainer component={Paper} sx={{ p: 2 }}>
                <Table
                    size="small"
                    sx={{ borderBottom: '1px solid rgba(0,0,0,0.1)' }}
                    aria-label="caption table"
                >
                    <TableBody>
                        <TableRow key={1}>
                            <TableCell align="left" sx={{ fontWeight: 'bold' }}>
                                No
                            </TableCell>
                            <TableCell align="left" sx={{ fontWeight: 'bold' }}>
                                Invoice Number
                            </TableCell>
                            <TableCell
                                align="center"
                                sx={{ fontWeight: 'bold' }}
                            >
                                Participant
                            </TableCell>
                            <TableCell
                                align="right"
                                sx={{ fontWeight: 'bold' }}
                            >
                                Total Amount
                            </TableCell>
                            <TableCell
                                align="center"
                                sx={{ fontWeight: 'bold' }}
                            >
                                Status
                            </TableCell>
                            <TableCell
                                align="center"
                                sx={{ fontWeight: 'bold' }}
                            >
                                Action
                            </TableCell>
                        </TableRow>

                        {tableData.length > 0 ? (
                            tableData.map((row, index) => (
                                <TableRow key={row.index}>
                                    <TableCell align="left">
                                        {index + 1}
                                    </TableCell>
                                    <TableCell>{row.invoiceNumber}</TableCell>
                                    <TableCell align="center">
                                        {row.countParticipant} Participant(s)
                                    </TableCell>
                                    <TableCell align="right">
                                        {formatCurrency(row.totalAmount)}
                                    </TableCell>
                                    <TableCell align="center">
                                        <Box
                                            component="span"
                                            sx={{
                                                display: 'inline-block',
                                                px: 1,
                                                py: 0.5,
                                                borderRadius: 1,
                                                fontSize: 12,
                                                fontWeight: 500,
                                                color:
                                                    row?.status?.color ||
                                                    '#424242',
                                                backgroundColor:
                                                    row?.status?.bgColor ||
                                                    '#eeeeee',
                                            }}
                                        >
                                            {row.status?.label || row.status}
                                        </Box>
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                        sx={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                        }}
                                    >
                                        <IconButton
                                            onClick={() => {
                                                navigate(
                                                    `/dashboard/group-registration/${row.id}`,
                                                );
                                            }}
                                        >
                                            <Tooltip title="Edit">
                                                <Edit
                                                    sx={{
                                                        color: 'text.disabled',
                                                        fontSize: 18,
                                                    }}
                                                />
                                            </Tooltip>
                                        </IconButton>
                                        <IconButton
                                            onClick={() =>
                                                deleteRegistration(row)
                                            }
                                            sx={{
                                                display: showButtonDelete(
                                                    row.status,
                                                ),
                                            }}
                                        >
                                            <Tooltip title="Delete">
                                                <Delete
                                                    sx={{
                                                        color: 'text.disabled',
                                                        fontSize: 18,
                                                    }}
                                                />
                                            </Tooltip>
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            ))
                        ) : (
                            <TableRow>
                                <TableCell
                                    align="left"
                                    colSpan={8}
                                    sx={{ textAlign: 'center' }}
                                >
                                    No Data
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
};

export default GroupRegistrationListPage;
